export default {
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
}
